import { actionToUrl, urlToAction } from '@respond-framework/rudy';
import URL from 'url-parse';
import {
  makeRoutesMapForOrigin,
  querySerializer,
} from '../../ReduxStorage/routesHelpers';
import { multiDomainRoutesMap } from '../../ReduxStorage/routesMap';
import { makeSelectOriginForAction } from '../../ReduxStorage/Institutions/CustomDomains/selectors';
import { CUSTOM_DOMAIN_INSTITUTIONS } from '../../ReduxStorage/Institutions/constants';

/* global _OL_ORIGIN */

// Use this if legacy code wants to be compatible with SPA without using the
// <Link /> component.
export const makeSelectUrlForAction = (action) => (state) => {
  const destinationOrigin = makeSelectOriginForAction(action)(state);
  const destinationRoutesMap = makeRoutesMapForOrigin(
    multiDomainRoutesMap,
    destinationOrigin
  );

  const destinationPath = actionToUrl(
    {
      ...action,
      // update params with institutionPrefix
      params: {
        institutionPrefix: (action.state || {}).institutionPrefix,
        ...action.params,
      },
    },
    {
      options: {
        ...querySerializer,
      },
      routes: destinationRoutesMap,
    }
  ).url;
  return `${destinationOrigin}${destinationPath}`;
};

export const getActionForUrl = (url) => {
  const { origin, hostname, pathname, query, hash } = new URL(url);

  const customDomain = CUSTOM_DOMAIN_INSTITUTIONS.find(
    (item) => item.get('domain') === hostname
  );

  if (origin !== _OL_ORIGIN && !customDomain) {
    // This URL is not one one of our domains
    return null;
  }
  const destinationRoutesMap = makeRoutesMapForOrigin(
    multiDomainRoutesMap,
    origin
  );

  const action = urlToAction(
    {
      routes: destinationRoutesMap,
      options: {
        ...querySerializer,
      },
    },
    `${pathname}${query}${hash}`
  );

  return {
    ...action,
    state: {
      ...action.state,
      institutionPrefix: customDomain
        ? customDomain.get('path')
        : action.params.institutionPrefix,
    },
  };
};
